import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6l6 6l-6 6","key":"svg-0"}],["path",{"d":"M17 5v13","key":"svg-1"}]]

const IconChevronRightPipe = createReactComponent('outline', 'chevron-right-pipe', 'ChevronRightPipe', __iconNode);

export default IconChevronRightPipe;